<template>
  <div class="ins-kpi" :class="toneClass" @click="clickable && $emit('click')">
    <div class="ins-kpi-label">
      {{ label }}
      <InsInfoTip v-if="tip || infoKey" :text="tip" :term-key="infoKey" :glossary="glossary" />
    </div>
    <div class="ins-kpi-value"><slot name="value">{{ value }}</slot></div>
    <div v-if="sub" class="ins-kpi-when">{{ sub }}</div>
    <slot></slot>
  </div>
</template>

<script>
/* One current-state KPI card. Flexible: any label/value, optional sub-line, optional info bubble,
 * optional click (emits `click`), and a `tone` that colors the left border. Composite values
 * (e.g. "Opened / Closed") go through the #value slot; extra content (e.g. a YoY compare block)
 * through the default slot. */
import InsInfoTip from "./InsInfoTip.vue";
export default {
  name: "InsKpiCard",
  components: { InsInfoTip },
  props: {
    label: { type: String, default: "" },
    value: { type: [String, Number], default: "" },
    sub: { type: String, default: "" },
    tone: { type: String, default: "default" }, // default | review | over | good | bad
    clickable: { type: Boolean, default: false },
    tip: { type: String, default: "" },
    infoKey: { type: String, default: "" },
    glossary: { type: Object, default: () => ({}) },
  },
  computed: {
    toneClass() {
      return {
        "ins-kpi--review": this.tone === "review",
        "ins-kpi--over": this.tone === "over",
        "ins-kpi--click": this.clickable,
      };
    },
  },
};
</script>
